import React, {useEffect, useState} from 'react';
import {View, Text, TouchableOpacity, StyleSheet} from 'react-native';
import {globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';

const TradingFeeDiscount = () => {
  return (
    <View style={[globalFontStyle.appFontSmallTextBold, {alignSelf: 'center'}]}>
      <Text
        style={[globalFontStyle.appFontSmallTextBold, {color: Colors.blue1}]}>
        50% off on trading fees for order above 200
      </Text>
    </View>
  );
};

export default TradingFeeDiscount;

const styles = StyleSheet.create({});
